import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { IoCopySharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Images from '../../Images';
import { capitalizeFirstLetter, handleCopy, truncateText } from '../../helpers';
import Tooltip from '../Tooltip';

const TenantMiniProfile = ({
  tenantId,
  name,
  mobile,
  profilePicture,
  kycStatus,
  flatName,
  truncateLength = 15,
  onClick,
  showCopy = true,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(`/tenantdetails/l/${tenantId}`, {
        state: { tenantId },
      });
    }
  };

  return (
    <div
      className="flex items-start gap-3 cursor-pointer"
      onClick={handleNavigate}
    >
      {/* Avatar */}
      <div className="relative shrink-0">
        <img
          src={profilePicture || Images.Avatar}
          alt={name}
          className="w-9 h-9 rounded-full object-cover"
        />

        {(kycStatus === 4 || kycStatus === 5) && (
          <span className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1">
            <FaCheck className="text-white" size={8} />
          </span>
        )}
      </div>

      {/* Name + Mobile */}
      <div className="flex flex-col min-w-0">
        <span className="font-medium text-gray-700 truncate"
        >
          <Tooltip label={flatName}>
            {capitalizeFirstLetter(truncateText(name, truncateLength))}
          </Tooltip>
        </span>


        {mobile && (
          <div className="flex items-center gap-1 text-xs text-gray-400">
            <span>{'#' + mobile}</span>

            {showCopy && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(mobile);
                }}
                className="hover:text-gray-600 transition"
                title="Copy number"
              >
                <IoCopySharp size={12} />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TenantMiniProfile;
